/** The guest's join result, kept per browser so a refresh keeps the table (wrapped: storage can be unavailable). */
export interface GuestSession {
  token: string;
  expiresAt: number;
  sessionId: string;
  tableName: string;
  restaurant: string;
  /** Session invite link for friends who arrive later (the table QR only works early in a sitting). */
  inviteUrl?: string;
  kind?: 'dine-in' | 'takeout';
}
const KEY = 'fm.guest';

export function loadGuest(): GuestSession | null {
  try {
    const g = JSON.parse(localStorage.getItem(KEY) ?? 'null') as GuestSession | null;
    return g && g.expiresAt > Date.now() ? g : null;
  } catch {
    return null;
  }
}

export function saveGuest(g: GuestSession | null) {
  try {
    if (g) localStorage.setItem(KEY, JSON.stringify(g));
    else localStorage.removeItem(KEY);
  } catch {
    /* private mode: the session lives in memory only */
  }
}
